// src/CacheManager.js - Portal do Cliente

class CacheManager {
    constructor() {
        this.clienteData = null;
        this.clienteDataDate = null;

        this.agendamentosCache = [];
        this.agendamentosById = {};
        this.agendamentosCacheDate = null;

        this.faturasCache = [];
        this.faturasById = {};
        this.faturasCacheDate = null;

        this.itensCache = [];
        this.itensById = {};
        this.itensCacheDate = null;

        this.espacosCache = [];
        this.espacosById = {};
        this.espacosCacheDate = null;

        this.sessionData = null;
    }

    setSessionData(sessionData) {
        this.sessionData = sessionData;
        this.invalidateAllCache();
    }

    getSessionData() {
        return this.sessionData;
    }

    clearSession() {
        this.sessionData = null;
        this.invalidateAllCache();
    }

    async loadData(url, nome, id_nome) {
        try {
            const response = await fetch(url);
            const data = await response.json();
            
            // Garantir que data é um array, mesmo se a API retornar um objeto de erro
            const dataArray = Array.isArray(data) ? data : [];
            
            this[`${nome}Cache`] = dataArray;
            this[`${nome}CacheDate`] = new Date();

            if (id_nome) {
                this[`${nome}ById`] = {};
                dataArray.forEach(item => {
                    this[`${nome}ById`][item[id_nome]] = item;
                });
            }
        } catch (error) {
            console.error(`Erro ao buscar dados de ${nome}:`, error);
            // Em caso de erro, garantir que o cache seja um array vazio
            this[`${nome}Cache`] = [];
            this[`${nome}ById`] = {};
        }
    }

    async getDataCache(nome) {
        if (!this[`${nome}CacheDate`] || (new Date() - this[`${nome}CacheDate`]) > 5 * 60 * 1000) {
            const loadMethod = `load${nome.charAt(0).toUpperCase() + nome.slice(1)}`;
            await this[loadMethod]();
        }
        // Garantir que sempre retorna um array
        return Array.isArray(this[`${nome}Cache`]) ? this[`${nome}Cache`] : [];
    }

    async getDataById(nome) {
        if (!this[`${nome}CacheDate`] || (new Date() - this[`${nome}CacheDate`]) > 5 * 60 * 1000) {
            const loadMethod = `load${nome.charAt(0).toUpperCase() + nome.slice(1)}`;
            await this[loadMethod]();
        }
        return this[`${nome}ById`];
    }

    async loadClienteData() {
        if (!this.sessionData || !this.sessionData.id_cliente) {
            console.error('Sessão não encontrada');
            return;
        }
        try {
            const response = await fetch(`https://novo.faestal.com.br/cliente/read.php?id=${this.sessionData.id_cliente}`);
            const data = await response.json();
            this.clienteData = data && data.length > 0 ? data[0] : null;
            this.clienteDataDate = new Date();
        } catch (error) {
            console.error('Erro ao buscar dados do cliente:', error);
        }
    }

    async loadAgendamentos() {
        if (!this.sessionData || !this.sessionData.id_cliente) {
            console.error('Sessão não encontrada');
            return;
        }
        await this.loadData(
            `https://novo.faestal.com.br/agendamento/read.php?id_cliente=${this.sessionData.id_cliente}`,
            'agendamentos',
            'id_agendamento'
        );
    }

    async loadFaturas() {
        if (!this.sessionData || !this.sessionData.id_cliente) {
            console.error('Sessão não encontrada');
            return;
        }
        await this.loadData(
            `https://novo.faestal.com.br/fatura/read.php?id_cliente=${this.sessionData.id_cliente}`,
            'faturas',
            'id_fatura'
        );
    }

    async loadItens() {
        await this.loadData('https://novo.faestal.com.br/item/read.php', 'itens', 'id_item');
    }

    async loadEspacos() {
        await this.loadData('https://novo.faestal.com.br/espaco/read.php', 'espacos', 'id_espaco');
    }

    async getClienteData() {
        if (!this.clienteDataDate || (new Date() - this.clienteDataDate) > 5 * 60 * 1000) {
            await this.loadClienteData();
        }
        return this.clienteData;
    }

    async getAgendamentosCache() {
        return this.getDataCache('agendamentos');
    }

    async getAllAgendamentosCache() {
        // Retorna todos os agendamentos (sem filtro de cliente)
        // Busca diretamente da API sem filtro
        try {
            const response = await fetch('https://novo.faestal.com.br/agendamento/read.php');
            const data = await response.json();
            return data || [];
        } catch (error) {
            console.error('Erro ao buscar todos os agendamentos:', error);
            return [];
        }
    }

    async getFaturasCache() {
        return this.getDataCache('faturas');
    }

    async getItensCache() {
        return this.getDataCache('itens');
    }

    async getEspacosCache() {
        return this.getDataCache('espacos');
    }

    async getAgendamentosById() {
        return this.getDataById('agendamentos');
    }

    async getFaturasById() {
        return this.getDataById('faturas');
    }

    async getItensById() {
        return this.getDataById('itens');
    }

    async getEspacosById() {
        return this.getDataById('espacos');
    }

    invalidateClienteData() {
        this.clienteData = null;
        this.clienteDataDate = null;
    }

    invalidateAgendamentosCache() {
        this.agendamentosCache = [];
        this.agendamentosCacheDate = null;
        this.agendamentosById = {};
    }

    invalidateFaturasCache() {
        this.faturasCache = [];
        this.faturasCacheDate = null;
        this.faturasById = {};
    }

    invalidateItensCache() {
        this.itensCache = [];
        this.itensCacheDate = null;
        this.itensById = {};
    }

    invalidateEspacosCache() {
        this.espacosCache = [];
        this.espacosCacheDate = null;
        this.espacosById = {};
    }

    invalidateAllCache() {
        this.invalidateClienteData();
        this.invalidateAgendamentosCache();
        this.invalidateFaturasCache();
        this.invalidateItensCache();
        this.invalidateEspacosCache();
    }
}

const cacheManager = new CacheManager();
export default cacheManager;
